import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Tooltip, OverlayTrigger, Button } from 'react-bootstrap';
import Loading from '../../../components/Loading/Loading';

import { ChartPlaceholder } from '../../../components/CardViews/CardViews';

import openInNewIcon from '../../../assets/img/open-in-new-black.svg';

import AnalysisItem from './AnalysisItem';
import XmrChart, { XMR_LABELS } from './XmrChart';

class InsightCardItem extends Component {
  constructor(props) {
    super(props);
    this.state = { showXmr: false };
  }

  componentDidUpdate() {
    if (this.state.showXmr && !this.props.xmr) {
      this.setState({ showXmr: false });
    }
  }

  handleXmrOpen = () => {
    this.setState({ showXmr: true });
  };

  handleXmrClose = () => {
    this.setState({ showXmr: false });
  };

  render() {
    return (
      <div className={`card-item ${this.props.className}`}>
        <div className='card-header'>
          <h4>
            {this.props.name}
            {this.props.status && this.props.status !== 'notenoughdata' &&
              <OverlayTrigger
                placement="bottom"
                overlay={
                  <Tooltip id="Tooltip" className='tooltip_dark'>
                    <p>
                      For more details, view the {this.props.chartName} here
                    </p>
                  </Tooltip>
                }
              >
                <Link to={`/dashboard/${this.props.dashboardId}/${this.props.chart}`} target="_blank" className={this.props.customizeMode ? '' : 'card-header-link'}><img src={openInNewIcon} alt="#" /></Link>
              </OverlayTrigger>
            }
          </h4>

          <div className='card-status'>
            {this.props.status && this.props.status.charAt(0).toUpperCase() + this.props.status.slice(1)}
          </div>
          <div className={`card-drag ${this.props.customizeMode ? '' : 'hidden'}`}>
            {/* Lucide "move" icon, ISC licence, https://lucide.dev */}
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M12 2v20" />
              <path d="m15 19-3 3-3-3" />
              <path d="m19 9 3 3-3 3" />
              <path d="M2 12h20" />
              <path d="m5 9-3 3 3 3" />
              <path d="m9 5 3-3 3 3" />
            </svg>
          </div>
        </div>

        <div className='card-content'>
          {!this.props.status && (
            <Loading />
          )}
          {this.props.status && (
            <React.Fragment>
              <AnalysisItem
                key={this.props.analisisLabelText ? this.props.analisisLabelText.replace(/ /g, ''): Math.random()}
                labelText={this.props.analisisLabelText}
                values={this.props.chartValues}
                valueType={this.props.valueType}
              ></AnalysisItem>

              {this.props.xmr && !this.props.customizeMode && (
                <div className="card-xmr-link">
                  <Button className="btn-detail" variant="outline-secondary" size="sm" onClick={this.handleXmrOpen}>
                    {XMR_LABELS.open_link} <img src={openInNewIcon} alt="" />
                  </Button>
                  <XmrChart
                    show={this.state.showXmr}
                    onHide={this.handleXmrClose}
                    analysisType={this.props.analysisType}
                    xmr={this.props.xmr}
                    replaceTasks={this.props.replaceTasks}
                  />
                </div>
              )}

              {this.props.noData && (
                <div className='notenoughdata-badge'>
                  <ChartPlaceholder shape={this.props.shape || 'columns'} textless />
                  <p className="chart-placeholder-text">{this.props.description}</p>
                </div>
              )}

              <div className='card-info'>
                <div className='card-info-description'>
                  <p key='description'>{this.props.description}</p>
                  <OverlayTrigger
                    placement="right"
                    overlay={
                      <Tooltip id="Tooltip" className='tooltip_dark max_width'>
                        <p>{this.props.text}</p>
                      </Tooltip>
                    }
                  >
                    <span className="more_info" />
                  </OverlayTrigger>
                </div>

                {this.props.children}
              </div>
            </React.Fragment>
          )}

        </div>
      </div>
    )
  }
}

export default InsightCardItem;
